<template>
    <div>

        <vue-headful title="Observations :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-comment-o"></i> Observations</li>
                <li class="ml-3">
                    <router-link :to="`/observations/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create Observation</router-link>
                </li>
            </ol>
        </h4>

        <template v-if="$store.state.user.is_admin">
            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                <template v-for="(tab, key) in settingsTabs">
                    <b-nav-item :active="curTab === key" @click="curTab = key">
                        {{ tab }}
                    </b-nav-item>
                </template>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
              <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
                <template v-for="(tab, key) in settingsTabs">
                    <b-dropdown-item :active="curTab === key" @click="curTab = key">
                        {{ tab }}
                    </b-dropdown-item>
                </template>
              </b-dropdown>
            </div>
        </template>

        <saved-filter-title :filterKey="'observationFilters'" />

        <div v-show="curTab === 'list'">
            <div class="card">
                <div class="card-body">
                    <div v-if="loading">
                        <i class="fa fa-circle-o-notch fa-spin"></i> Loading
                    </div>
                    <div v-else>

                        <observation-list ref="obsvTableList" :allowFilterSaving="true" :filterId="(filter_id ? parseInt(filter_id) : null)" />

                    </div>
                </div>
            </div>
        </div>
        <template v-if="$store.state.user.is_admin">
            <div v-show="curTab === 'settings'">
                <div class="card">
                    <div class="card-body">
                        <email-alert-list :assetType="'Observation'"></email-alert-list>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filter_id: this.$route.query.filter_id,
                loading: false,
                curTab: 'list',
                settingsTabs: {
                    list: 'Observations',
                    settings: 'Email Alert Settings',
                },
            }
        },

        computed: {
            tabButtonTitle(){
                //Send it
                return '<i class="fa fa-bars"></i> ' + this.settingsTabs[this.curTab];
            },
        },

        methods: {

        },

        mounted() {
            //Focus on the SEarch Input
            //this.$refs.obsvTableList.$refs.obsTable.$refs.genericFilter.focus();
        }
    }
</script>
